const ENVIRONMENT = {
  IS_PRODUCTION: process.env.REACT_APP_ENV === 'production',
  MAINTENANCE_MODE: process.env.REACT_APP_MAINTENANCE === 'yes',
  BASE_URL:
    process.env.REACT_APP_API_URL || 'https://api-dev.lionshare.app/api',
  ADMIN_URL: process.env.REACT_APP_ADMIN_URL,
  UPGRADE_PLAN_URL: process.env.REACT_APP_UPGRADE_PLAN_URL ?? '',
  UPLOADS_URL: `${process.env.REACT_APP_S3_URL}/uploads`,
  CDN_ASSETS_URL: `${process.env.REACT_APP_S3_URL}/cdn/assets`,
  REACT_APP_PUSHER_CLUSTER: (process.env.REACT_APP_PUSHER_CLUSTER ??
    '') as string,
  REACT_APP_PUSHER_KEY: (process.env.REACT_APP_PUSHER_KEY ?? '') as string,
  SENTRY_DNS: process.env.REACT_APP_SENTRY_DNS,
  SENTRY_ENVIRONMENT: process.env.REACT_APP_SENTRY_ENVIRONMENT ?? 'local',
  SENTRY_RELEASE: process.env.REACT_APP_SENTRY_RELEASE,
  GOOGLE_RECAPTCHA_KEY: process.env.REACT_APP_GOOGLE_RECAPTCHA_KEY ?? '',
  REACT_APP_RADAR_KEY: process.env.REACT_APP_RADAR_KEY,
  IS_DEV_ENV:
    !process.env.REACT_APP_API_URL ||
    process.env.REACT_APP_API_URL?.includes('api-dev'),
  STRIPE_PUBLISHABLE_KEY: process.env.REACT_APP_STRIPE_PK ?? '',
};

export default ENVIRONMENT;
